<template lang="pug">
  b-modal.send-email-form-modal(
    ref="modal"
    title="Enviar Correo"
    v-bind="$attrs"
    @show="onReset"
    @ok="onSubmit"
    :ok-disabled="loading"
    :cancel-disabled="loading"
    ok-title="Enviar")
    b-form
      b-form-group(label="Email")
        VueTagsInput(
          v-model="contactTagValue"
          placeholder="Correos de Contacto"
          :tags="contactTags"
          :validation="contactTagValidations"
          @tags-changed="newTags => { contactTags = newTags; contactTagValue = '' }"
        )
        .errors(v-if="$v.$dirty")
          b-form-invalid-feedback(:state="$v.form.email.required") Campo requerido
      b-form-group(label="Asunto")
        b-form-input(
          v-model="form.subject"
          list="subject-options"
          :state="$v.$dirty ? !$v.form.subject.$invalid : null"
        )
        datalist#subject-options
          option Pago Impuesto Mensual (F29)
          option Pago Previsión
        .errors(v-if="$v.$dirty")
          b-form-invalid-feedback(:state="$v.form.subject.required") Campo requerido
      b-form-group(label="Contenido")
        b-form-textarea(
          v-model="form.content"
          :state="$v.$dirty ? !$v.form.content.$invalid : null"
        )
        .errors(v-if="$v.$dirty")
          b-form-invalid-feedback(:state="$v.form.content.required") Campo requerido
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import { emailValidator } from '../../shared/validations'
import VueTagsInput from '@johmun/vue-tags-input'

export default {
  inheritAttrs: false,
  components: {
    VueTagsInput
  },
  data () {
    return {
      contactTags: [],
      contactTagValue: '',
      contactTagValidations: [
        {
          classes: 'avoid-item',
          rule: ({ text }) => !emailValidator(text)
        }
      ],
      loading: false,
      defaultEmail: '',
      businessId: null,
      form: {}
    }
  },
  validations: {
    form: {
      email: { required },
      subject: { required },
      content: { required }
    }
  },
  methods: {
    ...mapActions(['sendEmail']),
    showModal (options) {
      this.defaultEmail = options.defaultEmail || ''
      this.businessId =  options.businessId || null
      this.contactTags = options.defaultEmail ? options.defaultEmail.split(',').map(e => { return { text: e } }) : []
      this.$refs.modal.show()
    },
    onReset () {
      this.$v.$reset()
      this.form = {
        email: this.defaultEmail,
        subject: '',
        content: ''
      }
      this.contactTagValue = ''
      this.loading = false
    },
    async onSubmit (e) {
      if(this.$v.$invalid) {
        this.$v.$touch()
        e.preventDefault()
      } else {
        const data = {
          ...this.form,
          businessId:  this.businessId,
          emails: this.form.email.split(',')
        }
        const response = await this.sendEmail({ data })
        const status = response.status
        this.$root.$bvToast.toast(response.data.message, {
          title: status >= 200 && status < 300 ? 'Éxito!!' : 'Oops!!',
          variant: status >= 200 && status < 300 ? 'success' : 'danger'
        })
        this.loading = true
      }
      this.loading = false
    }
  },
  watch: {
    /**
     * Actualiza los email de contato separados por "," cada vez que cambian los tags de contacto
     */
    contactTags () {
      this.form.email = this.contactTags.map(e => e.text.trim()).join(',')
    }
  },
}
</script>
